import { render } from "./PurchaseMahadashaAnalysisReport.vue?vue&type=template&id=2c7963e9&scoped=true"
import script from "./PurchaseMahadashaAnalysisReport.vue?vue&type=script&lang=js"
export * from "./PurchaseMahadashaAnalysisReport.vue?vue&type=script&lang=js"

import "./PurchaseMahadashaAnalysisReport.vue?vue&type=style&index=0&id=2c7963e9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7963e9"]])

export default __exports__